module.exports = __webpack_public_path__ + "img/avatar.90e5272a.png";